// Recovered compiled webpack factory 73934. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { Gt: () => s, PP: () => a, WG: () => r, uv: () => o });
  var n = i(6500);
  let {
    schedule: s,
    cancel: r,
    state: o,
    steps: a,
  } = (0, i(44300).I)(
    "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : n.l,
    !0,
  );
}
